import _forEach from 'lodash/forEach';
import _set from 'lodash/set';
import _trim from 'lodash/trim';
import _isNil from 'lodash/isNil';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import { getFirestoreDeleteField } from '../system/firebase';
import { convertFirebaseTimestampsToDate } from './dateHelper';

export const deleteEmptyFields = dto => {
    const deleteField = getFirestoreDeleteField();
    const mappedDto = {};
    _forEach(dto, (value, key) => {
        _set(mappedDto, key, _isNil(value) || (typeof value === 'string' && _trim(value) === '') ? deleteField : value);
    });
    return mappedDto;
};

export const mapDefinedFields = dto => {
    const mappedDto = {};
    _forEach(dto, (value, key) => {
        // if (!_isNil(value) && (typeof value !== 'string' || _trim(value) !== '')) {
        if (value !== undefined) {
            _set(mappedDto, key, value);
        }
    });
    return mappedDto;
};

export const removeFromDto = (dto, toBeRemovedKeys = []) => {
    const newDto = {};
    _forEach(dto, (value, key) => {
        if (!_includes(toBeRemovedKeys, key)) {
            _set(newDto, key, value);
        }
    });
    return newDto;
};

export const mapProfileFromFirestore = ({ userId, dto }) => {
    const resumeList = dto?.resumeList;
    const mappedResumeList = _map(resumeList, resume => ({ ...convertFirebaseTimestampsToDate(resume, ['updateDt']) }));
    return { ...convertFirebaseTimestampsToDate(dto, ['createDt', 'updateDt']), resumeList: mappedResumeList, uid: userId };
};

export const mapJobHiredCandidateFromFirestore = ({ dto }) => {
    return { ...convertFirebaseTimestampsToDate(dto, ['createDt', 'updateDt']) };
};
